import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import useCart from '../../data/hooks/cart_hook';
import { RootState } from '../../data/reducers';
import { PrimaryButton } from '../../shared/components/common/primary_button';
import { CartProductTile } from '../../shared/components/product_components/cart_product_tile';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { formatAmount, getImageUrl } from '../../utility/common';
import CouponInput from './coupon_input';

export const Cart = () => {
  const { storeSlug } = useParams<any>();
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { cartItems, cartItemCount, cartSubTotalAmount, discount, cartTotalAmount, setCoupon, calculateTotal } =
    useCart();
  useEffect(() => {
    calculateTotal();
  }, [cartItems]);
  return (
    <NavigationShell title={`Checkout ${cartItemCount} items`} isBackVisible={true}>
      {cartItemCount > 0 ? (
        <div className="">
          {/*Add Cart Product listing */}
          <div className="flex-row px-6 pb-4">
            {cartItems.map((product) => {
              return <CartProductTile key={product.storeProductId} product={product} />;
            })}
          </div>

          <div className="w-full border-t border-gray-300"></div>

          <div className="flex-row md:flex-row px-6 pb-4 divide-y">
            {/* Sub Total */}
            <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
              <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
                Sub Total
              </div>
              <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
                {formatAmount(cartSubTotalAmount)}
              </div>
            </div>

            {/* Coupon */}
            {/* <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
              <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
                Coupon
              </div>
              <input
                type="text"
                className="w-1/2 md:w-1/2 flex flex-row-reverse md:flex md:flex-row-reverse form-control text-sm font-bold focus:outline-none text-right uppercase border w-"
                placeholder="Enter"
                value={discount}
                onChange={(e: any) => setCoupon(e.target.value.toUpperCase())}
              />
              <div className='w-28 text-sm'><PrimaryButton
                text="Apply"
                onclick={() => {
                  console.log("");
                }}
              /></div>
              
            </div> */}
            

            {/* Total */}
            <div className="flex md:flex bg-white pt-4 md:pt-4">
              <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
                Total
              </div>
              <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
                {formatAmount(cartTotalAmount)}
              </div>
            </div>
          </div>

          <div className="w-full border-t border-gray-300 mb-28"></div>

          <div className="p-6 fixed w-full md:w-1/2 bottom-0 bg-white">
            <Link to={`/${storeSlug}/buy/addressselect`}>
              <button className="w-full md:w-full p-3 md:p-3 bg-primaryViolet text-white font-medium rounded-xl">
                Checkout
              </button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="mx-6 mt-80">
          <div className="text-theLighterDark text-center my-4">Cart is empty</div>
          <Link to={`/${storeSlug}`}>
            <PrimaryButton text="Browse products" onclick={() => console.log('Browse products')} />
          </Link>
        </div>
      )}
    </NavigationShell>
  );
};
